import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/_atoms/button";

interface SidebarSectionToggleProps {
  label: string;
  expanded: boolean;
  onToggle: () => void;
  ariaControls?: string;
  testId?: string;
}

export const SidebarSectionToggle = ({ label, expanded, onToggle, ariaControls, testId }: SidebarSectionToggleProps) => {
  const { t } = useTranslation("common");
  const toggleVerb = expanded ? t("ariaLabels.closeVerb") : t("ariaLabels.open");

  return (
    <div className="relative mb-0.5 cursor-pointer rounded-md" data-testid={testId}>
      <Button
        variant="ghost"
        aria-label={`${toggleVerb} ${label}`}
        aria-expanded={expanded}
        aria-controls={ariaControls}
        className="my-0.5 flex h-auto w-full select-none flex-row items-center justify-between overflow-hidden text-ellipsis rounded-md p-0 pr-1 text-sm font-normal hover:bg-foreground/3 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus"
        onClick={onToggle}
      >
        <span className="pointer-events-none relative flex h-6 cursor-none items-center overflow-hidden text-ellipsis rounded-md pb-0 pl-1.5 pr-0.5 pt-0 text-xs text-foreground/80">
          {label}
        </span>
        <ChevronDown className={`mr-1 h-4 w-4 text-muted-foreground ${expanded ? "" : "-rotate-90"}`} />
      </Button>
    </div>
  );
};
